/*
 *
 * OrderPatientSearch reducer
 *
 */

import {fromJS} from "immutable";
import * as CONSTANTS from "./constants";

export const initialState = fromJS({
  patients: [],
  loading: false,
  error: "",
  total: 0,
});

function orderPatientSearchReducer(state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.GET_PATIENTS:
      return state.set("loading", true).set("error", "").set("total",0).set("patients", fromJS([]));

    case CONSTANTS.GET_PATIENTS_SUCCESS:
      return state
        .set("loading", false)
        .set("patients", fromJS(action.patients)).set("total", action.total);

    case CONSTANTS.GET_PATIENTS_ERROR:
      return state.set("loading", false).set("error", action.error).set("total",0).set("patients", fromJS([]));

    default:
      return state;
  }
}

export default orderPatientSearchReducer;
